import { render, staticRenderFns } from "./ListaConfiguracoes.vue?vue&type=template&id=cf3d6814&scoped=true&"
import script from "./ListaConfiguracoes.vue?vue&type=script&lang=js&"
export * from "./ListaConfiguracoes.vue?vue&type=script&lang=js&"
import style0 from "./ListaConfiguracoes.vue?vue&type=style&index=0&id=cf3d6814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3d6814",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
